// 支持的布局
export enum SUPPORT_LAYOUT {
  left = "left",
  center = "center",
  right = "right",
}
export enum LayoutKeyCode {
  ContractOperationSide = "ContractOperationSide",
  ContractDepthAndHistory = "ContractDepthAndHistory",
  ContractKline = "ContractKline",
  ContractPosition = "ContractPosition",
}
